import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './i18n'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import IBM Plex Serif font weights
import "@fontsource/ibm-plex-serif/300.css"; // Light
import "@fontsource/ibm-plex-serif/400.css"; // Regular
import "@fontsource/ibm-plex-serif/500.css"; // Medium
import "@fontsource/ibm-plex-serif/700.css"; // Bold

// Set default language to English if not already set
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'en');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
